import store from "client/store";

export default {
  path: 'import',
  component: () => import(/* webpackChunkName: "import" */ './wrapper.vue'),
  beforeEnter: function (to, from, next) {
    store.dispatch("imports.get", {
      eventDisciplineId: to.params.disciplineId,
    }).then(() => {
      next();
    });
  },
  children: [{
    path: '/',
    name: 'event.discipline.import',
    component: () => import(/* webpackChunkName: "import" */ './list.vue'),
  }, {
    path: 'add',
    component: () => import(/* webpackChunkName: "import" */ './add-wrapper.vue'),
    children: [{
      path: '/',
      name: 'event.discipline.import.add',
      component: () => import(/* webpackChunkName: "import" */ './add.vue'),
    }, {
      path: 'csv',
      name: 'event.discipline.import.add.csv',
      component: () => import(/* webpackChunkName: "import" */ './add-csv.vue'),
    }, {
      path: 'sce-event',
      name: 'event.discipline.import.add.sce-event',
      component: () => import(/* webpackChunkName: "import" */ './add-sce-event.vue'),
    }, {
      path: 'federation',
      name: 'event.discipline.import.add.federation',
      component: () => import(/* webpackChunkName: "import" */ './add-federation.vue'),
    }]
  }, {
    path: ':importId',
    beforeEnter: function (to, from, next) {
      store.dispatch("import.load", to.params.importId).then(() => {
        next();
      });
    },
    component: () => import(/* webpackChunkName: "import" */ './view.vue'),
    children: [{
      path: '/',
      name: 'event.discipline.import.view',
      component: () => import(/* webpackChunkName: "import" */ './viewSummary.vue'),
    }, {
      path: ':importType',
      name: 'event.discipline.import.view.detail',
      component: () => import(/* webpackChunkName: "import" */ './viewDetail.vue'),
    }]
  }],
}
